// extracted by mini-css-extract-plugin
export default {"homemenustats":"navbar_homemenustats__xUoAI"};